import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PropTypes from 'prop-types';
import React from 'react';
import {Button} from '@mui/material';

const ContactSupportButton = props => {
  return (
    <Button
      size="small"
      color="primary"
      variant="contained"
      href="https://support.planet.com/hc/en-us/requests/new"
      target="_blank"
      rel="noreferrer"
      endIcon={<OpenInNewIcon fontSize="small" />}
      {...props}
    >
      {props.label ? props.label : 'Report Issue'}
    </Button>
  );
};

ContactSupportButton.propTypes = {
  label: PropTypes.string,
};

export default ContactSupportButton;
